export const millisInADay = 86400000;
//# sourceMappingURL=constants.js.map